import { render, staticRenderFns } from "./CreateUserBtn.vue?vue&type=template&id=68762fad"
import script from "./CreateUserBtn.vue?vue&type=script&lang=ts"
export * from "./CreateUserBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports